import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=d43dd9a6&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"
import style0 from "./Departments.vue?vue&type=style&index=0&id=d43dd9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43dd9a6",
  null
  
)

export default component.exports